import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./providerDetails.html";
import { generateBadgeTooltips, generateLocalizedBadge } from '~/modules/helpers/badgeHelper';
import { selectSocialImpactFeatures } from '~/modules/helpers/listingHelper';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
import { parseNewLines } from '~/modules/utilities/text';
class ProviderDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.provider = void 0;
    this.listing = void 0;
  }
  i18nCallback(i18n) {
    this.labels = i18n.providerDetails;
    this.sharedLabels = i18n.shared;
  }
  get logo() {
    // @ts-expect-error * Automated Type Error Fix
    if (this.provider && this.provider['publisher/plugins/PublisherLogo']) {
      // @ts-expect-error * Automated Type Error Fix
      return generateMediaUrl(this.provider['publisher/plugins/PublisherLogo'].Logo);
    }
    return '';
  }
  get hasSocialImpact() {
    return this.socialImpactBadges.length;
  }
  get hasYearFounded() {
    return this.provider.yearFounded;
  }
  get hasEmail() {
    return this.provider.email;
  }
  get mailTo() {
    return `mailTo:${this.provider.email}`;
  }
  get hasWebsite() {
    return this.provider.website;
  }
  get hasPhoneNumber() {
    return this.provider.phoneNumber;
  }
  get formattedDescription() {
    // @ts-expect-error * Automated Type Error Fix
    return parseNewLines(this.provider.description);
  }
  get socialImpactBadges() {
    const socialImpactFeatures = selectSocialImpactFeatures(this.listing);
    return socialImpactFeatures.map(key => generateLocalizedBadge(key));
  }
  get socialImpactTooltip() {
    const extension = selectExtensionListing(this.listing);
    const socialImpactFeatures = selectSocialImpactFeatures(this.listing);
    return generateBadgeTooltips(socialImpactFeatures, extension);
  }
  get logoAlt() {
    return this.provider.name ? i18nStore.getState().i18n.shared.logoAlt({
      LOGO_NAME: this.provider.name
    }) : this.sharedLabels.deafultLogoAlt;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ProviderDetails, {
  publicProps: {
    provider: {
      config: 0
    },
    listing: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ProviderDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;